import resumeApi from "@/api/resume";
import { getDefaultSectionsDataForTemplate } from "@/helper/getDefaultSectionsDataForTemplate";
import { getDocumentTypes } from "@/store/documentType/selectors";
import { addResume, setActiveResume } from "@/store/resume/slice";
import { getSections } from "@/store/sections/selectors";
import { AppDispatch, store } from "@/store/store";
import { getTemplates } from "@/store/template/selectors";
import { setActiveTemplate } from "@/store/template/slice";
import { User } from "@/types";
import { ColumnLayout, DocumentVisibility, ResumeStyles } from "@/types/resume";
import { CLARITY_EVENT_NAMES } from "@/types/tracking";
import { trackClarityEvent, trackPostHogEvent } from "@/utils/tracking";
import { NavigateFunction } from "react-router-dom";

interface NewResumeOptions {
    styles?: ResumeStyles;
    columnLayout?: ColumnLayout;
    showImage?: boolean;
    userDetails: User;
    createAsTemplate?: boolean;
    isDesktop?: boolean;
    userJobId?: string;
}

export const createNewResume = (navigate: NavigateFunction, options?: NewResumeOptions) => {
    const { styles = {}, columnLayout = ColumnLayout.SINGLE, showImage = false, userDetails, createAsTemplate = false, isDesktop = false, userJobId } = options || {};
    const dispatch = store.dispatch as AppDispatch;
    const state = store.getState();
    const templates = getTemplates(state);
    const documentTypes = getDocumentTypes(state);
    const sections = getSections(state);

    const resumeTemplate = templates.find(t => t.name === "resume")!;
    const resumeDocumentType = documentTypes.find(
        t => t.name === "resume",
    )!;
    const { defaultSectionContent, defaultStyles } =
        getDefaultSectionsDataForTemplate(sections, resumeTemplate, styles, columnLayout, showImage, userDetails);

    resumeApi
        .createResume({
            sections: defaultSectionContent,
            name: "New Resume",
            styles: defaultStyles,
            template: resumeTemplate.id,
            columnLayout,
            documentType: resumeDocumentType.id,
            isTemplate: createAsTemplate,
            visibility: DocumentVisibility.PRIVATE,
            userJobId,
            tenantId: userDetails?.tenantId,
        })
        .then(resume => {
            dispatch(setActiveTemplate(resumeTemplate));
            dispatch(setActiveResume(resume));
            dispatch(addResume(resume));
            trackClarityEvent(CLARITY_EVENT_NAMES.NEW_RESUME_CREATED);
            trackPostHogEvent(CLARITY_EVENT_NAMES.NEW_RESUME_CREATED, {
                feature_name: "new_resume",
                isDesktop,
            });
            if (isDesktop) {
                navigate(`/resume/${resume.id}`, { replace: true });
            } else {
                navigate(`/preview/${resume.id}`, { replace: true });
            }
        });

};